function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 8V6c0-2.2-1.8-4-4-4s-4 1.8-4 4v2h-1c-.6 0-1 .4-1 1v6c0 1.7 1.3 3 3 3h6c1.7 0 3-1.3 3-3V9c0-.6-.4-1-1-1h-1zm-2 0V6c0-1.1-.9-2-2-2s-2 .9-2 2v2h4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgLock;